import { createSelector } from 'reselect';

import { RootState } from '../../../store';
import { getSelectionWindowMode } from './modes';
import { WindowToolTargetType } from './types';

export const getActiveSelectionWindowTargetType = createSelector(
  getSelectionWindowMode,

  (state: RootState) => state.selections.isSelectionWindowToolActive,
  (state: RootState) => state.selections.selectionWindowSettings,

  (mode, enabled, settings): WindowToolTargetType | null => (enabled ? settings[mode] : null),
);
